import { isNil } from 'lodash-es';
import { useOutletContext } from 'react-router-dom';

export type OutletContext = {
  clientId: string;
};

type WithRouteContextProps = {
  render: (context: OutletContext) => JSX.Element;
};

const WithRouteContext = ({ render }: WithRouteContextProps) => {
  const context = useOutletContext<OutletContext | null>();
  const { clientId } = context ?? {};

  if (isNil(clientId)) {
    // The AppErrorBoundaryFallback provides two options for the user to try to fix the error
    const clientIdError = new Error(
      'Sorry, account id was not found in route context. You can:',
    );
    clientIdError.name = 'ClientIdNotFoundError';
    throw clientIdError;
  }

  return render({ clientId });
};

export default WithRouteContext;
